const arrowDown = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polyline stroke-width="1.5" points="4 6 8.04 10 12 6.08"/></svg>',
};

export { arrowDown as default };
